import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PricingWebComponentComponent } from './pricing-web-component.component';
import { PricingWebComponentService } from './pricing-web-component.service';

@NgModule({
    imports: [
        CommonModule,
        PricingWebComponentComponent
    ],
    providers: [
        PricingWebComponentService
    ],
    exports: [
        PricingWebComponentComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PricingWebComponentModule { }
